// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckboxGroup__root--2vEvU","checkbox":"CheckboxGroup__checkbox--2pjqk"};